import { createContext } from 'react';

import useAuth from '../../hooks/useAuth.js';

const AuthContext = createContext();

const AuthProvider = ({ children }) => {
  const {
    loading,
    user,
    isAuth,
    handleLogin,
    handleAuthWithTokens,
    handleLogout,
    handleSetLoginOrigin,
    isMobileSession,
    refreshUser,
    socket,
  } = useAuth();

  return (
    <AuthContext.Provider
      value={{
        loading,
        user,
        isAuth,
        handleLogin,
        handleAuthWithTokens,
        handleLogout,
        handleSetLoginOrigin,
        isMobileSession,
        refreshUser,
        socket,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export { AuthContext, AuthProvider };
